module.exports = __webpack_public_path__ + "img/handraw_ancre.aae2c084.svg";